
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<ToggleSwitch>({})
export default class ToggleSwitch extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private value!: boolean;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: String, required: true }) private id!: string;
	@Prop({ type: String, default: 'statusGreen' }) private color!: string;
	@Prop({ type: String, default: '' }) private label!: string;
	@Prop({ type: String, default: '2.5rem' }) private labelMargin!: string;
	@Prop({ type: String, default: 'label-md' }) private labelClass!: string;
	@Prop({ type: [String, Array], default: '' }) private customClass!: string | string[];

	private get activeLabelClass(): string {
		return this.color + '--text';
	}

	private onSwitchChange(value: boolean): void {
		this.$emit('input', value);
		this.$emit('change', value);
	}
}
